import React from "react";
import {
  FaGlobeAfrica,
  FaUniversity,
  FaHome,
  FaFileContract,
  FaBalanceScale,
  FaBriefcase,
  FaClipboardCheck,
  FaCoins,
  FaGavel,
  FaRobot,
  FaCity,
  FaUsers,
  FaHandshake,
  FaBolt,
} from "react-icons/fa";

// FINAL PIXEL-PERFECT VERSION (Matched to 5alawfirm.com)

const sectors = [
  {
    id: "01",
    title: "Legal",
    highlight: "Representation",
    icon: <FaGavel />,
    tagline:
      "We do not practice law unless guided by knowledge, skill, and professional ethics",
    desc: "Our firm is committed to delivering high-quality legal representation grounded in integrity, expertise, and ethical responsibility. We represent clients with diligence and professionalism across a wide range of legal matters.",
    services: [
      { icon: <FaGavel />, label: "Court Representation" },
      { icon: <FaClipboardCheck />, label: "Legal Advocacy" },
      { icon: <FaHandshake />, label: "Case Handling" },
      { icon: <FaBriefcase />, label: "Client Representation" },
      { icon: <FaUsers />, label: "Individual & Corporate Cases" },
      { icon: <FaBalanceScale />, label: "Appeals & Defense" },
    ],
  },
  {
    id: "02",
    title: "Legal",
    highlight: "Consultancy",
    icon: <FaClipboardCheck />,
    reverse: true,
    tagline:
      "Clear, practical, and reliable legal advice tailored to your situation",
    desc: "We provide professional legal consultation services based on specific cases and client needs. Our advice is designed to help individuals, families, and organizations make informed legal decisions with confidence.",
    services: [
      { icon: <FaClipboardCheck />, label: "Legal Advice" },
      { icon: <FaUsers />, label: "Family Legal Support" },
      { icon: <FaBriefcase />, label: "Business Consultation" },
      { icon: <FaCoins />, label: "Financial & Contract Advice" },
      { icon: <FaGavel />, label: "Case-Based Guidance" },
      { icon: <FaUniversity />, label: "Regulatory Understanding" },
    ],
  },
  {
    id: "03",
    title: "Contracts &",
    highlight: "Documentation",
    icon: <FaFileContract />,
    tagline: "Drafting clear, enforceable, and legally sound agreements",
    desc: "We prepare and review a wide range of legal documents to ensure clarity, compliance, and protection of your rights. Our services cover contracts for individuals and businesses across different sectors.",
    services: [
      { icon: <FaFileContract />, label: "Contract Drafting" },
      { icon: <FaHome />, label: "Rental Agreements" },
      { icon: <FaBriefcase />, label: "Employment Contracts" },
      { icon: <FaHandshake />, label: "Business Agreements" },
      { icon: <FaCoins />, label: "Loan Agreements" },
      { icon: <FaClipboardCheck />, label: "Internal Regulations" },
    ],
  },
  {
    id: "04",
    title: "Negotiation &",
    highlight: "Settlement",
    icon: <FaHandshake />,
    reverse: true,
    tagline:
      "Resolving disputes efficiently through negotiation and mutual agreement",
    desc: "We offer professional mediation and negotiation services to resolve disputes outside of court whenever possible. Our goal is to achieve fair and efficient outcomes while saving time and resources for our clients.",
    services: [
      { icon: <FaHandshake />, label: "Negotiation Services" },
      { icon: <FaUsers />, label: "Mediation Support" },
      { icon: <FaBalanceScale />, label: "Dispute Settlement" },
      { icon: <FaGavel />, label: "Pre-Litigation Resolution" },
      { icon: <FaBriefcase />, label: "Business Disputes" },
      { icon: <FaHome />, label: "Family Settlements" },
    ],
  },
  {
    id: "05",
    title: "Training &",
    highlight: "Legal Support",
    icon: <FaUniversity />,
    tagline:
      "Empowering clients through legal knowledge, training, and ongoing support",
    desc: "In addition to legal services, we provide training and continuous legal support to individuals, families, organizations, and associations. Our approach ensures clients are informed, prepared, and protected.",
    services: [
      { icon: <FaUniversity />, label: "Legal Training" },
      { icon: <FaUsers />, label: "Community Support" },
      { icon: <FaBriefcase />, label: "Organizational Advisory" },
      { icon: <FaClipboardCheck />, label: "Compliance Guidance" },
      { icon: <FaGavel />, label: "Ongoing Legal Support" },
      { icon: <FaHandshake />, label: "Ethical Legal Practice" },
    ],
  },
];

export default function Sectors() {
  return (
    <section className="bg-[#f9f8f6] py-[90px]">
      <div className="max-w-[1200px] mx-auto px-2 md:px-6">
        {/* HEADER */}
        <div className="text-center mb-24">
          <div className="flex items-center justify-center gap-4 mb-6">
            <span className="h-[1px] w-12 bg-[#c9a227]" />
            <span className="uppercase text-xs tracking-[0.3em] text-[#c9a227]">
              Service
            </span>
            <span className="h-[1px] w-12 bg-[#c9a227]" />
          </div>

          <h2 className="text-[42px] font-serif text-[#1f2937]">
            Trusted Across <span className="text-[#c9a227]">Every Sector</span>
          </h2>

          <p className="mt-5 text-[#6b7280] max-w-2xl mx-auto text-[15px] leading-[1.8]">
            From multinational corporations entering Ethiopia to local
            institutions navigating regulatory change — we provide the legal
            certainty you need to move forward.
          </p>
        </div>

        {/* SECTORS */}
        <div className="max-w-[1200px] mx-auto px-1 md:px-6 space-y-16 md:space-y-28">
          {sectors.map((sec, i) => (
            <div
              key={i}
              className={`flex flex-col lg:flex-row ${
                sec.reverse ? "lg:flex-row-reverse " : ""
              }`}
            >
              {/* LEFT VISUAL */}
              {/* <div className="relative bg-[#0f1a2e] text-white px-10 py-16 overflow-hidden"> */}
              <div className="w-full lg:w-[420px] flex-shrink-0 bg-[#0f1a2e] text-white p-10 relative overflow-hidden">
                {/* TOP LINE */}
                <div className="absolute top-0 left-0 w-full h-[3px] bg-[#c9a227]" />

                {/* GRID BG */}
                <div
                  className="absolute inset-0 opacity-[0.06]"
                  style={{
                    backgroundImage:
                      "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg,#fff 1px, transparent 1px)",
                    backgroundSize: "50px 50px",
                  }}
                />

                {/* WATERMARK ICON */}
                <div className="absolute inset-0 flex items-center justify-center text-[140px] opacity-[0.05]">
                  {sec.icon}
                </div>

                {/* NUMBER */}
                <span className="absolute bottom-6 right-6 text-[110px] font-serif opacity-[0.08]">
                  {sec.id}
                </span>

                {/* CONTENT */}
                <div className="relative z-10 flex flex-col justify-center h-full">
                  {/* ICON BOX */}
                  <div className="w-14 h-14 border border-[#c9a227] bg-[#c9a22714] flex items-center justify-center text-[#c9a227] mb-8">
                    {sec.icon}
                  </div>

                  {/* TITLE */}
                  <h2 className="text-[32px] font-serif leading-[1.2] tracking-tight max-w-[260px]">
                    {sec.title}{" "}
                    <span className="text-[#c9a227]">{sec.highlight}</span>
                  </h2>

                  {/* SHORT UNDERLINE (NOT FULL WIDTH) */}
                  <span className="block w-[40px] h-[2px] bg-[#c9a227] mt-4 mb-5"></span>

                  {/* TAGLINE */}
                  <p className="text-[13.5px] text-gray-300 leading-[1.7] max-w-[240px]">
                    {sec.tagline}
                  </p>
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="bg-white px-4 md:px-12 py-10 md:py-16">
                <p className="text-[#4b5563] text-[15px] leading-[1.9] border-l-[3px] border-[#c9a227] pl-6 mb-10">
                  {sec.desc}
                </p>

                <div className="text-[11px] tracking-[0.3em] text-[#c9a227] uppercase mb-6">
                  Key Legal Services
                </div>

                <div className="grid sm:grid-cols-2 gap-2 md:gap-4">
                  {sec.services.map((s, idx) => (
                    <div
                      key={idx}
                      className="flex items-center gap-3 border border-[#e5e7eb] px-4 py-3 text-[14px] bg-[#f9f8f6] hover:bg-white transition-all duration-300"
                    >
                      <span className="text-[#c9a227]">{s.icon}</span>
                      {s.label}
                    </div>
                  ))}
                </div>

                <a
                  href="/appointment"
                  className="inline-flex items-center gap-2 mt-10 bg-[#1e3250] text-white px-8 py-3 text-[12px] tracking-[0.25em] uppercase hover:bg-[#2a4a6b] transition"
                >
                  Book Consultation →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
